/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProfessionalExperienceComponent = {
  id?: number
  type?: ProfessionalExperienceComponent.type
  from?: string
  to?: string
  title?: string
  description?: string
  finished?: boolean
}
export namespace ProfessionalExperienceComponent {
  export enum type {
    WORK = 'work',
    EDUCATION = 'education',
  }
}
